import React from 'react';
import { createRoot } from 'react-dom/client'; // Corrected import for React 18+
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';
import App from './App';
import './css/global.css'; // Assuming you have a global CSS file
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import AboutUs from './pages/AboutUs';
import Vision from './pages/Vision';
import Header from './components/Header';
import ContactUs from './pages/ContactUs';

// Create a root with React 18+
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/vision" element={<Vision />} />
        <Route path="/contact-us" element={<ContactUs />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

// Report web vitals (optional)
reportWebVitals();
